var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewer"},[(_vm.card.content)?_c('div',{ref:"editor"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }